import { Search } from '@shinetools/lumen-react'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedSearchInput } from '../../../../hooks/useDebouncedSearchInput'
import type { ExpertTrialBalanceColumnId } from '../../hooks/useExpertTrialBalanceColumns'
import { ExpertTrialBalanceColumnsMenu } from '../ExpertTrialBalanceColumnsMenu'
import { ExpertTrialBalanceExportMenu } from '../ExpertTrialBalanceExportMenu'
import * as Styled from './styles'

interface ExpertTrialBalanceToolbarProps {
  hiddenColumns: ExpertTrialBalanceColumnId[]
  search: string
  setHiddenColumns: (hiddenColumnIds: ExpertTrialBalanceColumnId[]) => void
  setSearch: (value: string) => void
}

export const ExpertTrialBalanceToolbar = ({
  hiddenColumns,
  search,
  setHiddenColumns,
  setSearch,
}: ExpertTrialBalanceToolbarProps): ReactElement => {
  const { t } = useTranslation()

  const handleSearchUpdate = useCallback(
    (value: string) => {
      setSearch(value)
    },
    [setSearch],
  )

  const { onChange: handleSearchChange, value: searchValue } = useDebouncedSearchInput(search, handleSearchUpdate)

  return (
    <Styled.ToolbarWrapper>
      <Styled.SearchWrapper>
        <Search
          rounded
          noDropdown
          onChange={handleSearchChange}
          placeholder={t('expert_trial_balance.toolbar.search.placeholder')}
          size="small"
          value={searchValue}
        />
      </Styled.SearchWrapper>
      <ExpertTrialBalanceColumnsMenu hiddenColumns={hiddenColumns} setHiddenColumns={setHiddenColumns} />
      <ExpertTrialBalanceExportMenu />
    </Styled.ToolbarWrapper>
  )
}
